<template>
    <div>
        <div class="config-row">
            <div class="custom-control form-check form-switch split-half" style="margin-top: 0">
                <input class="form-check-input" type="checkbox" role="switch" :id="`pushAllNodesToOltp`" :checked="config.push_all_nodes_to_oltp"
                    @click="setPushAllNodesToOltp(); updateConfig()" :disabled="!fieldInfo?.push_all_nodes_to_oltp?.editable || !editMode" />
                <label class="form-check-label" :for="`pushAllNodesToOltp`">
                    Push All Nodes to OLTP
                    <span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.push_all_nodes_to_oltp?.tooltip"
                        data-bs-toggle="tooltip" data-bs-placement="right"></span>
                </label>
            </div>
            <div class="custom-control form-check form-switch split-half" style="margin-top: 0">
                <input class="form-check-input" type="checkbox" role="switch" :id="`pushAllNodesToOltpRev`" :checked="config.push_all_nodes_to_oltp_rev"
                    @click="setPushAllNodesToOltpRev(); updateConfig()" :disabled="!fieldInfo?.push_all_nodes_to_oltp_rev?.editable || !editMode" />
                <label class="form-check-label" :for="`pushAllNodesToOltpRev`">
                    Push All Nodes to OLTP Reverse Nodes
                    <span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.push_all_nodes_to_oltp_rev?.tooltip"
                        data-bs-toggle="tooltip" data-bs-placement="right"></span>
                </label>
            </div>
        </div>
        <div class="config-row" v-if="!config.push_all_nodes_to_oltp || !config.push_all_nodes_to_oltp_rev">
            <div class="split-half">
                <div class="config-field" v-show="!config.push_all_nodes_to_oltp">
                    <div class="d-flex justify-content-between align-items-center">
                        <label class="form-label fw-bold pt-1">
                            Cluster to Neighbours OLTP
                            <span class="fa fa-circle-info text-muted ms-1"
                                :title="fieldInfo?.cluster_oltp_nodes?.tooltip" data-bs-toggle="tooltip"
                                data-bs-placement="right" :data-bs-html="true"></span>
                        </label>
                        <div class="pb-1">
                            <button v-if="fieldInfo?.cluster_oltp_nodes?.editable && editMode" type="button"
                                class="btn btn-sm btn-secondary" @click="resetToInitial('cluster_oltp_nodes')">
                                <i class="fa fa-rotate-left"></i> Reset
                            </button>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div v-if="config.cluster_oltp_nodes.length > 0">
                                <div v-for="(item, index) in config.cluster_oltp_nodes" :key="index" 
                                     class="mb-2 item-wrapper"
                                     :class="{ 'item-added': isNewItem('cluster_oltp_nodes', index), 'item-removing': isRemovingItem('cluster_oltp_nodes', index) }">
                                    <div class="input-group mb-1">
                                        <input type="text" class="form-control" :value="item" style="flex: 3;"
                                            @input="updateArrayItem('cluster_oltp_nodes', index, $event.target.value); updateConfig()"
                                            :disabled="!fieldInfo?.cluster_oltp_nodes?.editable || !editMode" placeholder="Node ID" />
                                        <button v-if="fieldInfo?.cluster_oltp_nodes?.editable && editMode" type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            @click="removeArrayItemWithAnimation('cluster_oltp_nodes', index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="text-muted">No data found!</p>
                            </div>
                            <div class="d-flex justify-content-end align-items-center">
                                <div>
                                    <button v-if="fieldInfo?.cluster_oltp_nodes?.editable && editMode" type="button"
                                        class="btn btn-sm btn-primary mt-2 btn-primary"
                                        @click="addArrayItemWithAnimation('cluster_oltp_nodes')">
                                        <i class="fa fa-plus"></i> Add Entry
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="split-half">
                <div class="config-field" v-show="!config.push_all_nodes_to_oltp_rev">
                    <div class="d-flex justify-content-between align-items-center">
                        <label class="form-label fw-bold pt-1">
                            Neighbours to Cluster OLTP
                            <span class="fa fa-circle-info text-muted ms-1"
                                :title="fieldInfo?.reverse_oltp_nodes?.tooltip" data-bs-toggle="tooltip"
                                data-bs-placement="right" :data-bs-html="true"></span>
                        </label>
                        <div class="pb-1">
                            <button v-if="fieldInfo?.reverse_oltp_nodes?.editable && editMode" type="button"
                                class="btn btn-sm btn-secondary" @click="resetToInitial('reverse_oltp_nodes')">
                                <i class="fa fa-rotate-left"></i> Reset
                            </button>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div v-if="config.reverse_oltp_nodes.length > 0">
                                <div v-for="(item, index) in config.reverse_oltp_nodes" :key="index" 
                                     class="mb-2 item-wrapper"
                                     :class="{ 'item-added': isNewItem('reverse_oltp_nodes', index), 'item-removing': isRemovingItem('reverse_oltp_nodes', index) }">
                                    <div class="input-group mb-1">
                                        <input type="text" class="form-control" :value="item" style="flex: 3;"
                                            @input="updateArrayItem('reverse_oltp_nodes', index, $event.target.value); updateConfig()"
                                            :disabled="!fieldInfo?.reverse_oltp_nodes?.editable || !editMode" placeholder="Node ID" />
                                        <button v-if="fieldInfo?.reverse_oltp_nodes?.editable && editMode" type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            @click="removeArrayItemWithAnimation('reverse_oltp_nodes', index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="text-muted">No data found!</p>
                            </div>
                            <div class="d-flex justify-content-end align-items-center">
                                <div>
                                    <button v-if="fieldInfo?.reverse_oltp_nodes?.editable && editMode" type="button"
                                        class="btn btn-sm btn-primary mt-2 btn-primary"
                                        @click="addArrayItemWithAnimation('reverse_oltp_nodes')">
                                        <i class="fa fa-plus"></i> Add Entry
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OltpConfigEasyMode',
    data() {
        return {
            config: {
				push_all_nodes_to_oltp: false,
				push_all_nodes_to_oltp_rev: false,
				reverse_oltp_nodes: [],
				cluster_oltp_nodes: [],
			},
			isLoadingFromParent: false,
            newItemIndexes: {
                cluster_oltp_nodes: new Set(),
                reverse_oltp_nodes: new Set()
            },
            removingItemIndexes: {
                cluster_oltp_nodes: new Set(),
                reverse_oltp_nodes: new Set()
            }
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({})
        },
        fieldInfo: {
            type: Object,
            default: () => ({})
        },
        cleanConfigFn: {
            type: Function,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        modelValue: {
            handler(newVal, oldVal) {
                // Only load config if it's actually different (not just a reference change)
				// This prevents overwriting local changes when switching tabs
				if (newVal && typeof newVal === 'object' && Object.keys(newVal).length > 0) {
					// Check if the config has actually changed by comparing key values
					if (!oldVal || !this.isConfigEqual(newVal, oldVal)) {
						this.isLoadingFromParent = true;
						this.loadConfig(newVal);
						this.$nextTick(() => {
							this.isLoadingFromParent = false;
						});
					}
				}
            },
            deep: true,
            immediate: false
        }
    },
    beforeMount() {
        if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
            this.loadConfig(this.modelValue);
        }
    },
    methods: {
        isConfigEqual(config1, config2) {
			// Deep comparison to check if configs are actually different
			if (!config1 || !config2) return false;
			const keys1 = Object.keys(config1);
			const keys2 = Object.keys(config2);
			if (keys1.length !== keys2.length) return false;

			for (let key of keys1) {
				if (JSON.stringify(config1[key]) !== JSON.stringify(config2[key])) {
					return false;
				}
			}
			return true;
		},
        updateConfig() {
            // Emit updated config to parent to maintain state
            // Don't emit if we're currently loading from parent (prevents infinite loop)
            if (!this.isLoadingFromParent) {
				this.$nextTick(() => {
					const configObj = this.cleanConfigFn(this.config);
					this.$emit('update:modelValue', configObj);
				});
			}
        },
        loadConfig(value) {
            if (!value || typeof value !== 'object') {
				return;
			}

            // Initialize config with prop values or defaults
            this.config = {
                push_all_nodes_to_oltp: value.push_all_nodes_to_oltp || false,
                push_all_nodes_to_oltp_rev: value.push_all_nodes_to_oltp_rev || false,
                reverse_oltp_nodes: value.reverse_oltp_nodes || [],
                cluster_oltp_nodes: value.cluster_oltp_nodes || [],
            };
        },
        resetToInitial(fieldName) {
            let config = JSON.parse(JSON.stringify(this.modelValue));
            config[fieldName] = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].initialValue));
            this.loadConfig(config);
            this.updateConfig();
        },
        setPushAllNodesToOltp() {
            this.config.push_all_nodes_to_oltp = !this.config.push_all_nodes_to_oltp;
        },
        setPushAllNodesToOltpRev() {
            this.config.push_all_nodes_to_oltp_rev = !this.config.push_all_nodes_to_oltp_rev;
        },
        isNewItem(fieldName, index) {
            return this.newItemIndexes[fieldName].has(index);
        },
        isRemovingItem(fieldName, index) {
            return this.removingItemIndexes[fieldName].has(index);
        },
        addArrayItemWithAnimation(fieldName) {
            const newIndex = this.config[fieldName].length;
            this.config[fieldName].push("");
            
            // Mark as new item
            this.newItemIndexes[fieldName].add(newIndex);
            
            // Remove the animation class after animation completes
            setTimeout(() => {
                this.newItemIndexes[fieldName].delete(newIndex);
            }, 300);
            
            this.updateConfig();
        },
        updateArrayItem(fieldName, index, value) {
            this.config[fieldName][index] = value;
            this.updateConfig();
        },
        removeArrayItemWithAnimation(fieldName, index) {
            // Mark as removing
            this.removingItemIndexes[fieldName].add(index);
            
            // Wait for animation to complete before actually removing
            setTimeout(() => {
                this.removingItemIndexes[fieldName].delete(index);
                this.config[fieldName].splice(index, 1);
                this.updateConfig();
            }, 300);
        },
        addArrayItem(fieldName) {
            this.config[fieldName].push("");
            this.updateConfig();
        },
        removeArrayItem(fieldName, index) {
            this.config[fieldName].splice(index, 1);
            this.updateConfig();
        },
    }
}
</script>

<style scoped>
.config-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    align-items: top;
}

.config-field {
    min-width: 300px;
    padding: 0.7rem;
    background-color: #fafafa;
    border-radius: 4px;
    box-sizing: border-box;
	border: 1px solid #838383;
	box-shadow: 4px 4px 4px rgb(204, 204, 204);}

@media (max-width: 768px) {
    .config-field {
        flex: 1 1 100%;
    }
}

.split-half {
    flex: 1 1 calc(50% - 0.5rem);
}

.input-group {
	display: flex;
	align-items: stretch;
}

.input-group .form-control {
	flex: 1;
}

.form-label {
	font-size: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.form-select {
	max-width: 100px;
	background-color: #f6f6f6;
}

.card {
	margin-bottom: 0rem;
}

/* Animation styles for item wrapper */
.item-wrapper {
    transition: all 0.4s ease;
}

/* Add item animation - scales in and fades in */
.item-added {
    animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
    0% {
        opacity: 0;
        transform: scale(0.8) translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

/* Remove item animation - slides out and fades */
.item-removing {
    animation: slideOut 0.4s ease forwards;
}

@keyframes slideOut {
    0% {
        opacity: 1;
        transform: translateX(0) scale(1);
        max-height: 100px;
        margin-bottom: 0.5rem;
    }
    100% {
        opacity: 0;
        transform: translateX(40px) scale(0.9);
        max-height: 0;
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>